/*
 * @Author: QiTianDaSheng
 * @Date: 2023-07-28 11:47:35
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-07-28 15:15:40
 */
import axios from './http'
import base from './base'

// 帮助中心的分类列表
export function getHelpClassifyList(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/helpClassify/getHelpClassifyList`,
    method: 'get',
    params,
  })
}

// 根据分类id获取内容列表
export function findHelpContentList(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/helpContent/findHelpContentList`,
    method: 'post',
    data: data,
  })
}

// 根据id获取内容详情
export function getHelpContent(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/helpContent/getHelpContent`,
    method: 'get',
    params,
  })
}